import React, {useState} from 'react';
import {Menu, Layout, ConfigProvider} from 'antd';
import {
    DashboardOutlined,
    UserOutlined,
    AppstoreOutlined,
    ShoppingCartOutlined,
    BarcodeOutlined,
    DollarOutlined,
    FileTextOutlined,
    TeamOutlined,
    BankOutlined,
    CalculatorOutlined,
    PieChartOutlined,
    SettingOutlined,
    LogoutOutlined
} from '@ant-design/icons';

import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {logout} from '../app/persistedSlice';
import {RootState} from "../app/store";
import {CoHrId} from "../data/constants";
import {useIsInRole} from "../hooks/Authorization/authorization";
import {AuthorizationIds} from "../hooks/Authorization/AuthorizationIds";

const {Sider} = Layout;
const {SubMenu, Divider} = Menu;

const SideMenu: React.FC = () => {
    const tenantInfo = useSelector((state: RootState) => state.persisted?.tenantInfo);
    const history = useHistory();
    const [selectedKeys, setSelectedKeys] = useState<string[]>([])
    const dispatch = useDispatch();

    const logoutClicked = () => {
        dispatch(logout())
        history.push(`/${tenantInfo?.id}/`);
    }

    const handleClick = (key: string) => {
        if (key === "logout") {
            setSelectedKeys([])
            logoutClicked()
            return
        }

        setSelectedKeys([key])
        if (key === "home") {
            history.push(`/${tenantInfo?.id}/`);
            return;
        }

        history.push(`/${tenantInfo?.id}/` + key.replaceAll("-", ""));
    };

    return (

        <Sider width={250} className="site-layout-background" style={{
            position: 'relative',
            height: 'calc(100vh - 90px)',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Menu theme='dark' mode="vertical" selectedKeys={selectedKeys}
                  style={{flex: '0 1 auto', borderRight: 0, marginTop: 10}} onSelect={(e) => {
                handleClick(e.key)
            }}>

                

                <Menu.Item
                    key="sales-create"
                    icon={<ShoppingCartOutlined />}
                    style={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        backgroundColor: '#1890ff',
                        color: '#fff',
                        borderRadius: '4px',
                        margin: '8px 0 8px 4px',
                        textAlign: 'center'
                    }}
                >
                    SATIŞ YAP
                </Menu.Item>

                <Menu.Item key="home" icon={<DashboardOutlined/>}>Ana Sayfa</Menu.Item>
                
                {useIsInRole([
                        AuthorizationIds.Roles.SuperAdmin,
                        AuthorizationIds.Roles.CompanyAdmin,
                        AuthorizationIds.Roles.StoreManager,
                        AuthorizationIds.Roles.Salesperson
                    ]) &&
                    <SubMenu key="customers" title="Müşteriler" icon={<UserOutlined/>}>
                        <Menu.Item key="customer-list">Müşteri Listesi</Menu.Item>
                        <Menu.Item key="customer-create">Yeni Müşteri</Menu.Item>
                        <Menu.Item key="prescriptions">Reçeteler</Menu.Item>
                    </SubMenu>
                }
                
                {useIsInRole([
                        AuthorizationIds.Roles.SuperAdmin,
                        AuthorizationIds.Roles.CompanyAdmin,
                        AuthorizationIds.Roles.StoreManager
                    ]) &&
                    <SubMenu key="products" title="Ürün ve Stok" icon={<AppstoreOutlined/>}>
                        <Menu.Item key="product-list">Ürün Listesi</Menu.Item>
                        <Menu.Item key="brands">Marka Yönetimi</Menu.Item>
                        <Menu.Item key="product-types">Ürün Tipleri</Menu.Item>
                        <Menu.Item key="stock-cards">Stok Kartları</Menu.Item>
                        <Menu.Item key="stock-transactions">Stok Giriş / Çıkış</Menu.Item>
                        <Menu.Item key="price-updates">Fiyat Güncellemeleri</Menu.Item>
                        <Menu.Item key="price-history">Fiyat Geçmişi</Menu.Item>
                    </SubMenu>
                }

                {useIsInRole([
                        AuthorizationIds.Roles.SuperAdmin,
                        AuthorizationIds.Roles.StoreManager,
                        AuthorizationIds.Roles.Salesperson
                    ]) &&
                    <SubMenu key="sales" title="Satışlar" icon={<ShoppingCartOutlined/>}>
                        <Menu.Item key="sales-list">Satış Listesi</Menu.Item>
                        <Menu.Item key="sales-create">Yeni Satış</Menu.Item>
                        <Menu.Item key="returns">İade İşlemleri</Menu.Item>
                        <Menu.Item key="payments">Tahsilatlar</Menu.Item>
                    </SubMenu>
                }

                {useIsInRole([
                        AuthorizationIds.Roles.SuperAdmin,
                        AuthorizationIds.Roles.StoreManager
                    ]) &&
                    <SubMenu key="orders" title="Siparişler" icon={<BarcodeOutlined/>}>
                        <Menu.Item key="orders-list">Sipariş Listesi</Menu.Item>
                        <Menu.Item key="orders-create">Sipariş Oluştur</Menu.Item>
                        <Menu.Item key="supplier-tracking">Tedarikçi Takibi</Menu.Item>
                    </SubMenu>
                }

                {useIsInRole([
                        AuthorizationIds.Roles.SuperAdmin,
                        AuthorizationIds.Roles.CompanyAdmin
                    ]) &&
                    <SubMenu key="reports" title="Raporlar" icon={<PieChartOutlined/>}>
                        <Menu.Item key="daily-cash-report">Günlük Kasa Raporu</Menu.Item>
                        <Menu.Item key="sales-performance">Satış Performansı</Menu.Item>
                        <Menu.Item key="stock-report">Stok Raporu</Menu.Item>
                    </SubMenu>
                }

                {useIsInRole([
                        AuthorizationIds.Roles.StoreManager
                    ]) &&
                    <SubMenu key="reports" title="Raporlar" icon={<PieChartOutlined/>}>
                        <Menu.Item key="daily-cash-report">Günlük Kasa Raporu</Menu.Item>
                    </SubMenu>
                }

                {useIsInRole([
                        AuthorizationIds.Roles.SuperAdmin,
                        AuthorizationIds.Roles.CompanyAdmin
                    ]) &&
                    <SubMenu key="staff" title="Personel" icon={<TeamOutlined/>}>
                        <Menu.Item key="staff-list">Personel Listesi</Menu.Item>
                    </SubMenu>
                }

                {useIsInRole([
                        AuthorizationIds.Roles.SuperAdmin,
                        AuthorizationIds.Roles.CompanyAdmin
                    ]) &&
                    <SubMenu key="branches" title="Şubeler" icon={<BankOutlined/>}>
                        <Menu.Item key="branch-list">Şube Listesi</Menu.Item>
                        <Menu.Item key="branch-create">Yeni Şube</Menu.Item>
                    </SubMenu>
                }

                {useIsInRole([
                        AuthorizationIds.Roles.SuperAdmin,
                        AuthorizationIds.Roles.CompanyAdmin,
                        AuthorizationIds.Roles.Accountant
                    ]) &&
                    <SubMenu key="accounting" title="Muhasebe" icon={<DollarOutlined/>}>
                        <Menu.Item key="cash-movements">Kasa Hareketleri</Menu.Item>
                        <Menu.Item key="expenses">Gider Takibi</Menu.Item>
                        <Menu.Item key="accounts">Cari Listesi</Menu.Item>
                    </SubMenu>
                }

            </Menu>
            <div style={{
                flex: '1 1 auto',
                overflowY: 'auto',
                borderRight: 0,
                maxHeight: 'calc(100vh - 150px)',
                position: "absolute",
                bottom: 0,
                width: "100%"
            }}>
                <Menu theme='dark' mode="vertical" selectedKeys={selectedKeys} onSelect={(e) => {
                    handleClick(e.key)
                }}>
                    <Divider style={{
                        borderWidth: 0.5,
                        borderColor: "rgba(255, 255, 255, 0.65)",
                        marginRight: 10,
                        marginLeft: 10,
                        marginBottom: 10
                    }}/>
                    {useIsInRole([AuthorizationIds.Roles.SuperAdmin, AuthorizationIds.Roles.CompanyAdmin]) &&
                        <SubMenu key="management" icon={<SettingOutlined/>} title="Yönetim Paneli">
                            <Menu.Item key="dashboard-screens">Dashboard Ekranları</Menu.Item>
                            {/*<Menu.Item key="nudging-emails">Dürtme Mailleri</Menu.Item>*/}
                            <Menu.Item key="user-role">Rol ve Yetki Tanımlamaları</Menu.Item>
                            <Menu.Item key="parameters">Parametreler</Menu.Item>
                            <Menu.Item key="users">Kullanıcılar</Menu.Item>
                        </SubMenu>
                    }
                    {tenantInfo?.companyGroupId === CoHrId &&
                        < SubMenu key="system_management" icon={<SettingOutlined/>} title="Sistem Yönetimi">
                            <Menu.Item key="company_groups">Şirketler</Menu.Item>
                            <Menu.Item key="logviewer">Sistem Logları</Menu.Item>
                        </SubMenu>
                    }
                </Menu>

                <Menu theme='dark' mode="inline" selectedKeys={selectedKeys}
                      style={{flex: '0 1 auto', borderRight: 0}}>
                    <Menu.Item key="logout" style={{paddingLeft: 16}} icon={<LogoutOutlined/>} onClick={() => {
                        handleClick("logout")
                    }}>
                        Çıkış
                    </Menu.Item>
                </Menu>
            </div>
        </Sider>
    );
};

export default SideMenu;
